import { ActivityIndicator, TextInput, TouchableOpacity, View } from "react-native";
import { applyCoupon, removeCoupon } from "appRedux/reducers/orderSlice";
import { useDispatch, useSelector } from "react-redux";

import { Colors } from "colors";
import ImageView from "../../../src/image";

import { Images } from "assets";
import React from "react";
import VText from "components/VText";
import { memo } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";

const PromoCode = () => {
    const [promoCode, setPromoCode] = useState("");
    const [msgText, setMsgText] = useState("");
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);

    const orderSummary = useSelector((state) => state.OrderReducer.orderSummary);
    const orderCoupon = useSelector((state) => state.OrderReducer.orderCoupon);
    const dispatch = useDispatch();

    useEffect(() => {
        if (orderCoupon) {
            setMsgText(orderCoupon?.message || "");
            setPromoCode(orderCoupon?.code);
        } else {
            setMsgText("");
            setPromoCode("");
        }
    }, [orderCoupon]);

    const checkPromoCode = () => {
        setIsError(false);
        setMsgText("");
        setLoading(true);
        let timer = setTimeout(() => {
            if (orderSummary?.coupons && Array.isArray(orderSummary?.coupons)) {
                let exists = orderSummary?.coupons?.find((o) => o?.code?.toLowerCase() == promoCode?.toLowerCase());
                if (exists) {
                    //   SimpleToast.show("Coupon Applied!");
                    setMsgText(exists?.message || "");
                    setLoading(false);
                    const eventData = {
                        promo_code: promoCode,
                        discount_value: exists?.discountAmount,
                        is_successful: true,
                    };
                    trackV2(ANALYTICS_EVENT_NAMES.PROMOTION_APPLIED, eventData);
                    dispatch(applyCoupon(exists));
                } else {
                    const eventData = {
                        promo_code: promoCode,
                        is_successful: false,
                        failure_reason: "invalid_code",
                    };
                    trackV2(ANALYTICS_EVENT_NAMES.PROMOTION_FAILED, eventData);
                    setLoading(false);
                    setIsError(true);
                    setMsgText("Invalid code");
                }
            } else {
                setLoading(false);
                setIsError(true);
                setMsgText("Invalid code");
            }
            clearTimeout(timer);
        }, 1000);
    };

    return (
        <View
            style={{
                backgroundColor: "white",
                marginTop: 10,
                zIndex: -100,
            }}
        >
            <VText
                text="Promotion Code"
                style={{
                    fontSize: 20,
                    fontWeight: "550",
                    lineheight: 28,
                    color: "#212427",
                }}
            />
            <View
                style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                    borderColor: isError
                        ? Colors.red
                        : orderCoupon
                        ? "#00000014"
                        : promoCode
                        ? Colors.black60
                        : Colors.greyBorder,
                    borderWidth: 1,
                    marginTop: 16,
                    paddingRight: 16,
                    backgroundColor: orderCoupon ? "#F7F7F7" : "white",
                }}
            >
                <TextInput
                    onChangeText={(e) => {
                        setPromoCode(e.trim().toUpperCase());
                        setMsgText("");
                        setIsError(false);
                    }}
                    style={{
                        padding: 16,
                        flex: 1,
                        fontSize: 20,
                        outlineStyle: "none",
                        color: promoCode.length ? "#000000" : "#2124274D",
                        fontFamily: "JosefinSans",
                    }}
                    editable={!orderCoupon}
                    autoCapitalize={true}
                    value={promoCode}
                    placeholder={"Enter coupon code here"}
                />
                {!loading && !orderCoupon && !isError && (
                    <TouchableOpacity
                        style={{
                            opacity: promoCode?.length > 3 ? 1 : 0.4,
                        }}
                        disabled={promoCode?.length < 4}
                        onPress={checkPromoCode}
                        activeOpacity={(0, 8)}
                    >
                        <VText
                            text="Apply"
                            style={{
                                fontSize: 20,
                                fontWeight: "550",
                                lineHeight: 24,
                                color: "#212427",
                            }}
                        />
                    </TouchableOpacity>
                )}
                {loading && <ActivityIndicator animating={loading} color={Colors.black} size={40} />}
                {(orderCoupon || isError) && (
                    <TouchableOpacity
                        style={{
                            padding: 16,
                            paddingRight: 0,
                        }}
                        onPress={() => {
                            dispatch(removeCoupon());
                            setPromoCode("");
                            setIsError(false);
                            setMsgText("");
                            if (!isError) {
                                // SimpleToast.show("Coupon Removed!");
                            }
                        }}
                    >
                        <ImageView source={Images.crossIcon} style={{ width: 12, height: 12 }} />
                    </TouchableOpacity>
                )}
            </View>
            {msgText && (
                <VText
                    text={msgText}
                    style={{
                        fontSize: 13,
                        fontWeight: "350",
                        lineHeight: 20,
                        color: isError ? "#CE1A1A" : "#149B08",
                        paddingTop: 8,
                    }}
                />
            )}
        </View>
    );
};

export default memo(PromoCode);
